import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  BD_PERSON,
  CREATE_ORDER_DRAFT,
  DELETE_ORDER_DRAFT,
  PLACE_ORDER_REQUEST,
  PRODUCT_WITH_PRICE,
} from "../../constants/apiConstants";
import { getApi, postApi } from "../../../services/apiServices";
import Alertify from "../../../services/alertify";

/*----------------BD Person ---------------- */
export const BdPerson = createAsyncThunk("BdPerson/admin", async () => {
  try {
    const response = await getApi(BD_PERSON);
    return response;
  } catch (error) {
    console.log("Error BD Person API", error);
    Alertify.error(error.message);
    return Promise.reject(error);
  }
});

/*---------------- Product details with prices ---------------- */
export const PDetailsPrice = createAsyncThunk(
  "Product_details_with_price/admin",
  async (reqData) => {
    try {
      const response = await postApi(PRODUCT_WITH_PRICE, reqData);
      return response;
    } catch (error) {
      console.log("Error Product Details with Price API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Place Order Request ---------------- */
export const PlaceOrderRequest = createAsyncThunk(
  "Place_order_request/admin",
  async (reqData) => {
    try {
      const response = await postApi(PLACE_ORDER_REQUEST, reqData);
      return response;
    } catch (error) {
      console.log("Error Place Order Request API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Save Draft ---------------- */
export const SaveDraft = createAsyncThunk(
  "save_draft/admin",
  async (reqData) => {
    try {
      const response = await postApi(CREATE_ORDER_DRAFT, reqData);
      return response;
    } catch (error) {
      console.log("Error Create Order Draft API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Delete Order Draft ---------------- */
export const DeleteOrderDraft = createAsyncThunk(
  "delete-order-draft/admin",
  async (reqData) => {
    try {
      const response = await postApi(DELETE_ORDER_DRAFT, reqData);
      return response;
    } catch (error) {
      console.log("Error Delete Order Draft API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
